<template>
  <div id="FullModal">
    <div class="popup">
      <div class="title">
        <slot name="title"/>
        <button class="close" @click="close">
          <img src="@/assets/icon/close.svg"/>
        </button>
      </div>
      <div class="content">
        <slot name="content"/>
      </div>
      <div class="buttons">
        <slot name="buttons"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullModal',
  props: ['title', 'content', 'button'],
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
#FullModal {
  position: fixed;
  top: 0;
  display: flex;
  width: 100%;
  max-width: inherit;
  max-height: 100vh;
  margin: auto;
  background-color: rgba(51, 51, 51, 0.6);
  z-index: 999;

  .popup {
    background-color: #ffffff;
    border-top-left-radius: calc(12% / 375 * 100);
    border-top-right-radius: calc(12% / 375 * 100);
    animation: modal-popup-show 0.3s;
    max-height: calc(100% - 2.9vh);
    overflow: scroll;
    align-self: flex-end;

    /*Slot*/
    .title > div, .content > div, .buttons > div {
      width: 100%;
    }
    .title > div {
      width: 100%;
      font-size: 18px;
      text-align: center;
      font-weight: 900;
      line-height: 1.67;
      b {
        font-weight: 700;
      }
    }
    .title > .close {
      position: absolute;
      top: 0px;
      right: 25px;
    }
    .content > div {
      width: 100%;
      font-size: 18px;
      text-align: center;
      line-height: 1.67;
      color: #333333;
      b {
        font-weight: 900;
      }
    }
    .buttons > div {
      width: 100%;
      background-color: #d7e1ea;
      font-weight: 900;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      button {
        height: 9vh;
        font-weight: 900;
        @media screen and (max-width: 350px) {
          font-size: 15px;
        }
        @media screen and (min-width: 350px) {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
